const IMAGETYPE_GIF = 1;
const IMAGETYPE_JPEG = 2;
const IMAGETYPE_PNG = 3;
const IMAGETYPE_SWF = 4;
const IMAGETYPE_PSD = 5;
const IMAGETYPE_BMP = 6;
const IMAGETYPE_TIFF_II = 7; // Also known as IMAGETYPE_TIFF_LE in some contexts
const IMAGETYPE_TIFF_MM = 8;
const IMAGETYPE_JPC = 9;
const IMAGETYPE_JP2 = 10;
const IMAGETYPE_JPX = 11;
const IMAGETYPE_JB2 = 12;
const IMAGETYPE_SWC = 13;
const IMAGETYPE_IFF = 14;
const IMAGETYPE_WBMP = 15;
const IMAGETYPE_XBM = 16;
const IMAGETYPE_WEBP = 17;
function subdirize(str, count = 3, uselast = false) {
    const orig = str;
    if (count > str.length) {
        count = str.length;
    }
    const dotpos = str.indexOf('.');
    if (dotpos > 0 && count > dotpos) {
        count = dotpos;
    }
    if (count < 1) {
        return false;
    }
    // Replace any non-alphanumeric character with '_'
    let sanitized = str.replace(/[^A-Za-z0-9]/g, '_');
    if (uselast) {
        // Reverse the string if required
        sanitized = sanitized.split('').reverse().join('');
    }
    let newstring = '';
    for(let i = 0; i < count; i++){
        newstring += `${sanitized.charAt(i)}/`;
    }
    newstring += orig;
    return newstring;
}
function safe_filename(filename) {
    filename = filename.replace(/[ /:]/g, '_');
    filename = filename.toLowerCase();
    if (filename.charAt(0) === '.') {
        filename = `_${filename}`;
    }
    return filename.replace(/[^a-z0-9_.-]+/g, '-');
}
function da_image_type_to_extension(imagetype, include_dot = true) {
    if (!imagetype) {
        return false;
    }
    const dot = include_dot ? '.' : '';
    switch(imagetype){
        case IMAGETYPE_GIF:
            return `${dot}gif`;
        case IMAGETYPE_JPEG:
            return `${dot}jpg`;
        case IMAGETYPE_PNG:
            return `${dot}png`;
        case IMAGETYPE_SWF:
            return `${dot}swf`;
        case IMAGETYPE_PSD:
            return `${dot}psd`;
        case IMAGETYPE_BMP:
            return `${dot}bmp`;
        case IMAGETYPE_WBMP:
            return `${dot}wbmp`;
        case IMAGETYPE_XBM:
            return `${dot}xbm`;
        case IMAGETYPE_TIFF_II:
        case IMAGETYPE_TIFF_MM:
            return `${dot}tiff`;
        case IMAGETYPE_IFF:
            return `${dot}aiff`;
        case IMAGETYPE_JB2:
            return `${dot}jb2`;
        case IMAGETYPE_JPC:
            return `${dot}jpc`;
        case IMAGETYPE_JP2:
            return `${dot}jp2`;
        case IMAGETYPE_JPX:
            return `${dot}jpf`;
        case IMAGETYPE_SWC:
            return `${dot}swf`;
        case IMAGETYPE_WEBP:
            return `${dot}webp`;
        default:
            return false;
    }
}
/**
 * Port of PHP logic:
 *
 * markup.lib.php$218?view=highlighted
 * vms/lib/files/path/v./dapath.php$696
 *
 */ export function makeAvatarUrl(username, usericon = 1) {
    try {
        if (!username) {
            return '';
        }
        // Grab the lower 2 bits of $iconformat, the next 4 bits are used for cache busting
        const iconformat = usericon & 0x3;
        const cachebuster = usericon >> 2 & 0xf;
        const ext = da_image_type_to_extension(iconformat);
        let fileurl = `https://a.deviantart.net/avatars/${subdirize(safe_filename(username), 2)}${ext}`;
        if (cachebuster) {
            fileurl = `${fileurl}?$cachebuster`;
        }
        return `${fileurl}`;
    } catch (e) {
        return '';
    }
}

//# sourceMappingURL=avatar.js.map